export const CHAT_BOT_COMPONENT_CONFIG = `const componentConfig = {%multipleSources%
    "theme": "%themeComposer%",
    "config": {
        "apiBaseUrl": "%intelligenceApiUrl%",
        "timeout": 60%chatBotMode%%chatBotAllowModeSwitch%
    }%onClose%
}`;

export const CHAT_BOT_MULTIPLE_SOURCES = `
    "sources": [
        "%sourceId%",
        "%additionalSourceId%"
    ],`;

export const CHAT_BOT_SINGLE_SOURCE = `
    "sources": [
        "%sourceId%"
    ],`;

export const CHAT_BOT_ON_CLOSE = `,
    "onClose": () => {
        alert('Chatbot close button clicked!');
        // Optional: Hide container or perform other actions
        // document.getElementById('widget-holder').style.display = 'none';
    }`;

export const CHAT_BOT_EVENT_LISTENERS_CODE = `

        // START: Event Listeners
        // When the event is triggered in this example, a message pop-up
        // launches.  Please read the Documentation Helper for a description
        // of other available event listeners.
        component.addEventListener("composer-chat-bot-loaded", (e) => {
            alert("Chatbot has been loaded for the first time!");
        });
        /* END: Event Listeners */`;

export const CHAT_BOT_READY_EVENT_LISTENER = `
        component.addEventListener("composer-chat-bot-ready", (e) => {
            alert("Chatbot is ready for interaction!");
        });`;

export const CHAT_BOT_FAILED_EVENT_LISTENER = `
        component.addEventListener("composer-chat-bot-failed", (e) => {
            alert("Chatbot failed to initialize: " + e.detail.failedReason);
        });`;

export const CHAT_BOT_CLOSED_EVENT_LISTENER = `
        component.addEventListener("composer-chat-bot-closed", (e) => {
            alert("Chatbot has been closed by the user!");
        });`;

export const CHAT_BOT_MESSAGE_SENT_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-sent", (e) => {
            alert("Message sent: " + e.detail.text);
        });`;

export const CHAT_BOT_MESSAGE_RECEIVED_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-received", (e) => {
            alert("Message received: " + e.detail.text);
        });`;

export const CHAT_BOT_MESSAGE_TIMEOUT_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-timeout", (e) => {
            alert("Message request timed out: " + e.detail.text);
        });`;

export const CHAT_BOT_MESSAGE_ABORTED_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-aborted", (e) => {
            alert("Message request aborted: " + e.detail.text);
        });`;

export const CHAT_BOT_MESSAGE_COPIED_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-copied", (e) => {
            alert("Message copied to clipboard: " + e.detail.text);
        });`;

export const CHAT_BOT_MESSAGE_UPVOTED_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-upvoted", (e) => {
            alert("Message upvoted. Record ID: " + e.detail.recordId + ", Feedback Type: " + e.detail.feedbackType);
        });`;

export const CHAT_BOT_MESSAGE_DOWNVOTED_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-downvoted", (e) => {
            alert("Message downvoted. Record ID: " + e.detail.recordId + ", Feedback Type: " + e.detail.feedbackType);
        });`;

export const CHAT_BOT_MESSAGE_ERROR_EVENT_LISTENER = `
        component.addEventListener("composer-chat-message-error", (e) => {
            alert("Message error: " + e.detail.text + ", Reason: " + e.detail.failedReason);
        });`;

export const CHAT_BOT_SUGGESTIONS_FAILED_EVENT_LISTENER = `
        component.addEventListener("composer-bot-suggestions-failed", (e) => {
            alert("Suggestions failed to load: " + e.detail.failedReason);
        });`;

export const CHAT_BOT_BOT_API_JS_CODE = `

        // START: Bot API
        // Fired once the chatbot's programmatic API is available after initialization.
        // Access via e.detail.api or the component.api getter after this event.
        component.addEventListener("composer-chat-bot-api-ready", (e) => {
            window.botApi = e.detail.api;
            showApiOutput("Bot API ready — use the controls on the left to interact programmatically.");
        });
        /* END: Bot API */`;

export const CHAT_BOT_BOT_API_HELPERS_JS_CODE = `

const showApiOutput = (msg) => {
    const el = document.getElementById('api-output');
    if (el) el.textContent = msg;
};

const onSendMessage = () => {
    if (!window.botApi) { showApiOutput('API not ready yet. Wait for the chatbot to finish loading.'); return; }
    const input = document.getElementById('message-input');
    const text = input ? input.value.trim() : '';
    if (!text) { showApiOutput('Please enter a message first.'); return; }
    window.botApi.sendMessage(text);
    showApiOutput('Sent: "' + text + '"');
};

const onGetMessages = () => {
    if (!window.botApi) { showApiOutput('API not ready yet.'); return; }
    const msgs = window.botApi.getMessages();
    showApiOutput('Conversation has ' + msgs.length + ' message(s).');
};

const onClearMessages = () => {
    if (!window.botApi) { showApiOutput('API not ready yet.'); return; }
    window.botApi.clearMessages();
    showApiOutput('Conversation cleared.');
};

const onStopRequest = () => {
    if (!window.botApi) { showApiOutput('API not ready yet.'); return; }
    window.botApi.stopRequest();
    showApiOutput('Active request stopped.');
};

const onGetMode = () => {
    if (!window.botApi) { showApiOutput('API not ready yet.'); return; }
    showApiOutput('Current mode: ' + window.botApi.getMode());
};

const onSetMode = () => {
    if (!window.botApi) { showApiOutput('API not ready yet.'); return; }
    const select = document.getElementById('mode-select');
    const mode = select ? select.value : 'none';
    window.botApi.setMode(mode);
    showApiOutput('Mode changed to: ' + mode);
};

const onGetSuggestions = () => {
    if (!window.botApi) { showApiOutput('API not ready yet.'); return; }
    const suggestions = window.botApi.getSuggestions();
    if (!suggestions.length) {
        showApiOutput('No suggestions available yet.');
    } else {
        showApiOutput(suggestions.length + ' suggestion(s): ' + suggestions.map(s => '"' + s.query + '"').join(', '));
    }
};

const onCheckStatus = () => {
    if (!window.botApi) { showApiOutput('API not ready yet.'); return; }
    showApiOutput('isReady: ' + window.botApi.isReady + ' | isLoading: ' + window.botApi.isLoading);
};`;

export const CHAT_BOT_BOT_API_HTML_CODE = `

    <!-- START: Bot API controls panel -->
    <div class="api-panel">
        <div class="api-panel-title">Bot API Demo</div>
        <div class="api-row">
            <input type="text" id="message-input" class="api-input" placeholder="Type a message..." onkeydown="if(event.key==='Enter')onSendMessage()" />
            <button class="api-btn api-btn-primary" onclick="onSendMessage()">Send</button>
        </div>
        <div class="api-row">
            <button class="api-btn" onclick="onGetMessages()">Get Messages</button>
            <button class="api-btn" onclick="onClearMessages()">Clear</button>
            <button class="api-btn" onclick="onStopRequest()">Stop</button>
        </div>
        <div class="api-row">
            <button class="api-btn" onclick="onGetMode()">Get Mode</button>
            <select id="mode-select" class="api-select">
                <option value="none">None</option>
                <option value="auto">Auto</option>
                <option value="visual">Visual</option>
            </select>
            <button class="api-btn" onclick="onSetMode()">Set Mode</button>
        </div>
        <div class="api-row">
            <button class="api-btn" onclick="onGetSuggestions()">Get Suggestions</button>
            <button class="api-btn" onclick="onCheckStatus()">Check Status</button>
        </div>
        <div id="api-output" class="api-output">API not ready yet.</div>
    </div>
    <!-- END: Bot API controls panel -->`;

export const CHAT_BOT_BOT_API_CSS_CODE = `

.api-panel {
    width: 240px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background: #f8f9fa;
    border-right: 1px solid #ddd;
    font-family: Arial, sans-serif;
    font-size: 13px;
    overflow-y: auto;
}

.api-panel-title {
    font-weight: 700;
    font-size: 14px;
    color: #885a90;
    margin-bottom: 4px;
}

.api-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
}

.api-input {
    flex: 1;
    min-width: 0;
    padding: 5px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 12px;
}

.api-select {
    flex: 1;
    min-width: 0;
    padding: 5px 4px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 12px;
}

.api-btn {
    padding: 5px 10px;
    background: #ffffff;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
}

.api-btn:hover {
    background: #f0f0f0;
}

.api-btn-primary {
    background: #885a90;
    color: #ffffff;
    border-color: #885a90;
}

.api-btn-primary:hover {
    background: #6d4574;
}

.api-output {
    margin-top: 6px;
    padding: 8px;
    background: #fff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 11px;
    color: #333;
    min-height: 32px;
    word-break: break-word;
}`;
